var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._tabData.length > 1 ? _c('div', {
    staticClass: "pro_chiose_tabs"
  }, _vm._l(_vm._tabData, function (item) {
    return _c('div', {
      key: item.value,
      staticClass: "tab_item",
      class: {
        tab_item_action: _vm.value === item.value
      },
      on: {
        "click": function ($event) {
          return _vm.onChange(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 0) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };